export type Phase = "ready" | "spinning" | "reveal";

const PLACEHOLDER = "? ? ? ?";

export type ReelRowProps = {
  /** 1-based round number rendered in the leading badge. */
  rowNumber: number;
  /** Index of this row within the visible window — drives staggered spin
   *  speeds so the reels look like they're decelerating independently. */
  rowIndex: number;
  phase: Phase;
  /** The committed pick for this round, or null if the source list was empty. */
  pick: string | null;
  /** Beer names rendered as a vertically-scrolling reel during the spin. */
  reelStrip: string[];
};

/** One row of the slot machine — round number badge on the left, the
 *  scrolling reel on the right. Phase decides whether the reel is the
 *  placeholder, the animated strip, or the revealed pick. */
const ReelRow = ({
  rowNumber,
  rowIndex,
  phase,
  pick,
  reelStrip,
}: ReelRowProps) => {
  const beerName = phase === "ready" ? PLACEHOLDER : pick ?? PLACEHOLDER;
  return (
    <div className="row">
      <div className="row-num">{rowNumber}</div>
      <div className="reel">
        {phase === "spinning" ? (
          <div
            className="reel-strip"
            // Each row gets a slightly different duration so the reels
            // look like they're decelerating at independent rates.
            style={{ animationDuration: `${0.18 + rowIndex * 0.04}s` }}
          >
            {reelStrip.map((b, j) => (
              <div className="reel-strip-item" key={j}>
                {b}
              </div>
            ))}
          </div>
        ) : (
          <span
            className={`reel-text reel-text--${
              phase === "ready" ? "placeholder" : "reveal"
            }`}
          >
            {beerName}
          </span>
        )}
      </div>
    </div>
  );
};

export default ReelRow;
